<template>
  <v-container fluid class="flex-grow-1 overflow pt-1 pb-0">
    <IncidentDataForm v-model:incident="incident"></IncidentDataForm>
  </v-container>
</template>

<script lang="ts" setup>
// Framework import
import type { PropType, Ref } from 'vue'
import { onMounted } from 'vue'

import { useVModel } from '@vueuse/core'

//Types import
import { getCategories, getComplexity, getDisplayModes } from '@/services/api/masterData'
import type { Incident, Category, Complexity, DisplayMode } from '@/types/Incident'

// Components import
import IncidentDataForm from './IncidentDataForm.vue'

// Services import

const props = defineProps({
  modelValue: {
    type: Object as PropType<Partial<Incident>>,
    required: true
  },
  editting: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits<{
  (event: 'closeIncidentInfoEvent'): void
  (event: 'save'): void
  (event: 'update:modelValue', v: Partial<Incident>): void
}>()

const incident = useVModel(props, 'modelValue', emits) as Ref<Partial<Incident>>

onMounted(async () => {
  incident.value.category = incident.value.category || (await getCategories()).find((x: Category) => x.name == 'Wildfire')
  incident.value.complexity = incident.value.complexity || (await getComplexity()).find((x: Complexity) => x.name == 'None')
  incident.value.displayMode = incident.value.displayMode || (await getDisplayModes()).find((x: DisplayMode) => x.name == 'private')
  incident.value.incident_number = ''
})
</script>

<style>
.v-field__outline__end {
  color: rgb(var(--v-theme-lighten));
}
.overflow {
  overflow-y: auto;
}
</style>
<style scoped>
.betterMargins {
  margin-left: -16px;
  margin-right: -16px;
}
</style>
